import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { switchMap, tap } from 'rxjs/operators';
import { AuthenticationService } from 'src/app/core/service/auth.service';
import { environment } from 'src/environments/environment';
import { ConfigurationType } from './project-setting.service';

@Injectable({
  providedIn: 'root'
})
export class BoardServiceService {
  handleError: any;
  headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  constructor(private http: HttpClient,
    private auth: AuthenticationService) {
  }

  /*sprints */
  createSprint(data: any, projectId: number): any {
    return this.http.post<any>(environment.API_URL + `/api/projects/${projectId}/sprints`, data, { headers: this.headers })
  }
  editSprint(sprintId: number, data: any): any {
    return this.http.patch<any>(environment.API_URL + `/api/sprints/${sprintId}`, data, { headers: this.headers })
  }

  startSprint(sprintId: number) {
    return this.http.patch<any>(environment.API_URL + `/api/sprints/${sprintId}/start`, { headers: this.headers })

  }
  finishSprint(sprintId: number) {
    return this.http.patch<any>(environment.API_URL + `/api/sprints/${sprintId}/finish`, { headers: this.headers })
  }
  suspendSprint(sprintId: number) {
    return this.http.patch<any>(environment.API_URL + `/api/sprints/${sprintId}/suspend`, { headers: this.headers })
  }

  getSprintsByProject(projectId: number) {
    return this.http.get<any>(environment.API_URL + `/api/sprints?query[projectId]=${projectId}&sort=id:ASC`);
  }

  getSprintsActiveByProject(projectId: number) {
    return this.http.get<any>(environment.API_URL + `/api/projects/${projectId}/sprints/current`);
  }

  getSprint(id: number) {
    return this.http.get<any>(environment.API_URL + `/api/sprints/${id}`);
  }

  getLastStartedTasks(){
    return this.http.get<any>(environment.API_URL + `/api/tasks/lastStarted`);
  }

  getSprintTeamMembers(idProject: number, idSprint: number, search?: any) {
    let params = new HttpParams();
    params = params.appendAll({
      relations: 'user',
      pageSize: 7,
      page: 1
    })

    if (search && search !== '') {
      params = params.appendAll({
        searchFields: 'user.firstName,user.lastName',
        search
      });
    }
    return this.http.get<any>(environment.API_URL + `/api/projects/${idProject}/sprints/${idSprint}/members`, { params });
  }

  getDashBoardInfo(projectId: number) {
    return this.http.get<any>(environment.API_URL + `/api/projects/${projectId}/dashboard`);
  }

  getAllSprintsForTable(pageSize: number, page: number, projectId: number, search?: string) {
    let params = new HttpParams();
    params = params.appendAll({
      relations: 'team,manager',
      pageSize,
      page
    });

    if (search && search !== '') {
      params = params.appendAll({
        searchFields: 'name,manager.firstName,manager.lastName,team.name',
        search
      });
    }
    return this.http.get<any>(environment.API_URL + `/api/projects/${projectId}/sprints`, { params });
  }

  getSprintsDropdown(projectId: number, search?: string) {
    let params = new HttpParams();
    params = params.appendAll({
      pageSize: 7,
      page: 1,
      relations: 'team,team.members,team.members.user'
    });

    if (search && search !== '') {
      params = params.appendAll({
        searchFields: 'name',
        search
      });
    }
    return this.http.get<any>(environment.API_URL + `/api/projects/${projectId}/sprints`, { params });
  }

  deleteSprint(idSprint: number) {
    return this.http.delete<any>(environment.API_URL + `/api/sprints/${idSprint}`);
  }

  /*TASKS */
  getTask(id: number) {
    return this.http.get<any>(environment.API_URL + `/api/tasks/${id}?relations=uploadedFiles,author,author.photo,assignedInitials,assigned,assigned.photo,sprint,parent,column,priority,type`);
  }

  createTask(projectId: number, data: any) {
    return this.http.post<any>(environment.API_URL + `/api/projects/${projectId}/tasks`, data, { headers: this.headers })
  }

  updateTask(projectId: number, data: any, taskId: number) {
    return this.http.patch<any>(environment.API_URL + `/api/projects/${projectId}/tasks/${taskId}`, data, { headers: this.headers })
  }

  timeUpdate(projectId: number, data: any, taskId: number) {
    return this.http.patch<any>(environment.API_URL + `/api/tasks/timeUpdate/${taskId}`, data, { headers: this.headers })
  }
 

  deleteTask(idTask: number) {
    return this.http.delete<any>(environment.API_URL + `/api/tasks/${idTask}`);
  }

  getAllTasksForTable(pageSize: number, page: number, projectId: number, filter?: any, sort?: any, search?: string) {
    let params = new HttpParams();
    params = params.appendAll({
      pageSize,
      page,
      relations: 'assigned,sprint,column,priority,type,assignedInitials,uploadedFiles,author,requirement',
    });

    if (search && search !== '') {
      params = params.appendAll({
        searchFields: `title,description,impediments,notes,requestedBy,assigned.firstName,assigned.lastName`,
        search
      });
    }

    if (filter) {
      if (filter.sprintId && filter.sprintId == 0) params = params.append('queryNull[sprintId]', filter.sprintId);
      else if (filter.sprintId && filter.sprintId != 0 && filter.sprintId != '') params = params.append('query[sprintId]', filter.sprintId);

      if (filter.columnId && filter.columnId != '') params = params.append('query[columnId]', filter.columnId);
      if (filter.priorityId && filter.priorityId != '') params = params.append('query[priorityId]', filter.priorityId);
      if (filter.assignedId && filter.assignedId != '') params = params.append('query[assignedId]', filter.assignedId);
      if (filter.typeId && filter.typeId != '') params = params.append('query[typeId]', filter.typeId);
      // if (filter.plannedStatus && filter.plannedStatus !== null) params = params.append('query[plannedTask]', filter.plannedStatus);
    }

    //TODO: sort by relation fields (example: priority.description) and sort by multiple fields (example: assigned.firstName,assigned.lastName)
    if (sort) {
      let multipleSort = sort.sortField.split(',');
      if (multipleSort.length > 0) {
        for (let index = 0; index < multipleSort.length; index++) {
          multipleSort[index] = `${multipleSort[index]}:${sort.sortOrder === 1 ? 'ASC' : 'DESC'}`;
        }
        params = params.append('sort', multipleSort.toString());
      } else params = params.append('sort', `${sort.sortField}:${sort.sortOrder === 1 ? 'ASC' : 'DESC'}`);
    } else params.append('sort', 'id:DESC');

    return this.http.get<any>(environment.API_URL + `/api/projects/${projectId}/tasks`, { params });
  }
  
  getAllTasksByBugForTable(pageSize: number, page: number, projectId: number,bugId:number,search?: string) {
    let params = new HttpParams();
    params = params.appendAll({
      pageSize,
      page,
      relations: 'sprint,column,priority,type',
      sort: 'id:DESC',
      'query[bugId]': bugId
    });

    if (search && search !== '') {
      params = params.appendAll({
        searchFields: `title,description,impediments,notes,requestedBy,assigned.firstName,assigned.lastName`,
        search
      });
    }
    return this.http.get<any>(environment.API_URL + `/api/projects/${projectId}/tasks`, { params });
  }

  getTasksByColumnSprint( projectId: number,columnId:any,sprintId:any,search?: string) {
    let params = new HttpParams();
    params = params.appendAll({
      pageSize:15,
      page:1,
      sort: 'boardIndex:ASC',
    });
    
    if (sprintId == -1  || sprintId == 0 || sprintId == null) params = params.append('queryNull[sprintId]', 0);
      else if (sprintId && sprintId != -1 && sprintId != '') params = params.append('query[sprintId]', sprintId);

    if (columnId == -1  || columnId == 0 || columnId == null) params = params.append('queryNull[columnId]', 0);
      else if (columnId && columnId != -1 && columnId != '') params = params.append('query[columnId]', columnId);

    if (search && search !== '') {
      params = params.appendAll({
        searchFields: `title,description,impediments,notes,requestedBy,assigned.firstName,assigned.lastName`,
        search
      });
    }
    return this.http.get<any>(environment.API_URL + `/api/projects/${projectId}/tasks`, { params });
  }
  getTasksBySprint( projectId: number,sprintId:any,search?: string) {
    let params = new HttpParams();
    params = params.appendAll({
      pageSize:15,
      page:1,
      sort: 'boardIndex:ASC',
    });
    
    if (sprintId == -1  || sprintId == 0 || sprintId == null) params = params.append('queryNull[sprintId]', 0);
      else if (sprintId && sprintId != -1 && sprintId != '') params = params.append('query[sprintId]', sprintId);

    if (search && search !== '') {
      params = params.appendAll({
        searchFields: `title,description,impediments,notes,requestedBy,assigned.firstName,assigned.lastName`,
        search
      });
    }
    return this.http.get<any>(environment.API_URL + `/api/projects/${projectId}/tasks`, { params });
  }

  getAllTasksForBoard(projectId: number, pageSize: number, page: number, columnId?: number, filter?: any, search?: any) {
    let params = new HttpParams();
    params = params.appendAll({
      pageSize,
      page,
      relations: 'assigned,uploadedFiles,sprint,column,priority,type,assignedInitials',
      sort: 'boardIndex:ASC'
    });

    if (columnId) params = params.append('query[columnId]', columnId);
    else params = params.append('queryNull[columnId]', null as any);

    if (search && search !== '') {
      params = params.appendAll({
        searchFields: `title,description,impediments,notes,requestedBy,assigned.firstName,assigned.lastName`,
        search
      });
    }

    if (filter) {
      if (filter.sprintId !== null && filter.sprintId == 0) params = params.append('queryNull[sprintId]', filter.sprintId);
      else if (filter.sprintId !== null && filter.sprintId != 0 && filter.sprintId != '') params = params.append('query[sprintId]', filter.sprintId);

      // if (filter.columnId !== null && filter.columnId != '') params = params.append('query[columnId]', filter.columnId);
      if (filter.priorityId !== null && filter.priorityId != '') params = params.append('query[priorityId]', filter.priorityId);
      if (filter.assignedId !== null && filter.assignedId != '') params = params.append('query[assignedId]', filter.assignedId);
      if (filter.typeId !== null && filter.typeId != '') params = params.append('query[typeId]', filter.typeId);
      // if (filter.plannedStatus !== null) params = params.append('query[plannedTask]', filter.plannedStatus);
    }

    return this.http.get<any>(environment.API_URL + `/api/projects/${projectId}/tasks`, { params });
  }

  getTasksForSprintBoard(sprintId: number, projectId: number, pageSize: number, page: number, filter?: any, search?: any) {
    let params = new HttpParams();
    params = params.appendAll({
      pageSize,
      page,
      relations: 'assigned,uploadedFiles,sprint,column,priority,type,assignedInitials',
      sort: 'sprintIndex:ASC'
    });

    if (search && search !== '') {
      params = params.appendAll({
        searchFields: `title,description,impediments,notes,requestedBy,assigned.firstName,assigned.lastName`,
        search
      });
    }

    if (sprintId !== null) params = params.append('query[sprintId]', sprintId);

    if (filter) {
      if (filter.columnId && filter.columnId != '') params = params.append('query[columnId]', filter.columnId);
      if (filter.priorityId && filter.priorityId != '') params = params.append('query[priorityId]', filter.priorityId);
      if (filter.assignedId && filter.assignedId != '') params = params.append('query[assignedId]', filter.assignedId);
      if (filter.typeId && filter.typeId != '') params = params.append('query[typeId]', filter.typeId);
      // if (filter.plannedStatus) params = params.append('query[plannedTask]', filter.plannedStatus);
    }

    return this.http.get<any>(environment.API_URL + `/api/projects/${projectId}/tasks`, { params });
  }

  getTasksForDashboard(sprintId: number, projectId: number) {
    return this.http.get<any>(environment.API_URL + `/api/projects/${projectId}/tasks?relations=assigned&query[sprintId]=${sprintId}&sort=startDate:ASC`);
  }

  // getAllTasksForTaskBoard(projectId: number, pageSize: number, page: number, idColumn: number) {
  //   return this.http.get<any>(environment.API_URL + `/api/projects/${projectId}/tasks?pageSize=${pageSize}&page=${page}&relations=assigned,sprint,column,priority,type,assignedInitials&query[columnId]=${idColumn}&sort=id:DESC`);
  // }

  getAllBacklogTasksForBoard(sprintId: number | null, projectId: number, pageSize: number, page: number, filter: any) {
    let params = new HttpParams();
    params = params.appendAll({
      relations: 'assigned,sprint,column,priority,type,assignedInitials,uploadedFiles',
      pageSize,
      page,
      sort: 'id:DESC'
    });

    if (filter) {
      if (filter.columnId && filter.columnId !== '') params = params.append('query[columnId]', filter.columnId);
      else params = params.append('queryNull[columnId]', true);
      if (filter.priorityId && filter.priorityId !== '') params = params.append('query[priorityId]', filter.priorityId);
      if (filter.assignedId && filter.assignedId !== '') params = params.append('query[assignedId]', filter.assignedId);
      if (filter.typeId && filter.typeId !== '') params = params.append('query[typeId]', filter.typeId);
      // if (filter.plannedStatus != null) params = params.append('query[plannedTask]', filter.plannedStatus);
    }

    if (sprintId == null || sprintId == 0) {
      return this.http.get<any>(environment.API_URL + `/api/projects/${projectId}/tasks/no-sprint`, { params });
    } else {
      return this.http.get<any>(environment.API_URL + `/api/sprints/${sprintId}/tasks`, { params });
    }
  }


  getBackLogForSprintBoard(projectId: number, pageSize: number, page: number, filter: any) {
    let params = new HttpParams();
    params = params.appendAll({
      relations: 'assigned,sprint,column,priority,type,assignedInitials,uploadedFiles',
      pageSize,
      page,
      sort: 'sprintIndex:ASC'
    });

    if (filter) {
      if (filter.columnId != null) params = params.append('query[columnId]', filter.columnId);
      //else params = params.append('queryNull[columnId]', true);
      if (filter.priorityId != null) params = params.append('query[priorityId]', filter.priorityId);
      if (filter.assignedId != null) params = params.append('query[assignedId]', filter.assignedId);
      if (filter.typeId != null) params = params.append('query[typeId]', filter.typeId);
      // if (filter.plannedStatus != null) params = params.append('query[plannedTask]', filter.plannedStatus);
    }

    return this.http.get<any>(environment.API_URL + `/api/projects/${projectId}/tasks/no-sprint`, { params });
  }

  getAllBacklogTasksForTaskBoard(projectId: number, pageSize: number, page: number) {

    return this.http.get<any>(environment.API_URL + `/api/projects/${projectId}/tasks?pageSize=${pageSize}&page=${page}&relations=assigned,sprint,column,priority,type,assignedInitials&queryNull[columnId]=true&sort=id:DESC`);

  }

  toggleTask(taskId: number) {
    return this.http.post<any>(environment.API_URL + `/api/tasks/${taskId}/toogleTracking`, { headers: this.headers })
  }
  changeColumn(taskId: number, data: any) {
    return this.http.patch<any>(environment.API_URL + `/api/tasks/${taskId}/changeColumn`, data, { headers: this.headers })
  }
  moveColumn(projectId: number, data: any) {
    return this.http.patch<any>(environment.API_URL + `/api/projects/${projectId}/scrumboard-columns/indexing`, data, { headers: this.headers })
  }
  changeSprint(taskId: number, data: any) {
    return this.http.patch<any>(environment.API_URL + `/api/tasks/${taskId}/changeSprint`, data, { headers: this.headers })
  }


  /*data */

  createColumn(projectId: number | null, data: any) {
    return this.http.post<any>(environment.API_URL + `/api/projects/${projectId}/scrumboard-columns`, data, { headers: this.headers })
  }

  updateColumn(projectId: number | null, columnId: number, data: any) {
    return this.http.patch<any>(environment.API_URL + `/api/projects/${projectId}/scrumboard-columns/${columnId}`, data, { headers: this.headers })
  }
  deleteColumn(projectId: number | null, columnId: number) {
    return this.http.delete<any>(environment.API_URL + `/api/projects/${projectId}/scrumboard-columns/${columnId}`)
  }

  getConfigurations(projectId: number, type: ConfigurationType, search?: string) {
    let params = new HttpParams();
    params = params.appendAll({
      pageSize: 7,
      page: 1,
      sort: 'description:ASC',
      'query[type]': type
    });

    if (search && search !== '') {
      params = params.appendAll({
        searchFields: 'description',
        search
      });
    }

    return this.http.get<any>(environment.API_URL + `/api/projects/${projectId}/configurations`, { params });
  }
  getConfigurationsAll(projectId: number, type: ConfigurationType, search?: string) {
    let params = new HttpParams();
    params = params.appendAll({
      sort: 'description:ASC',
      'query[type]': type
    });

    if (search && search !== '') {
      params = params.appendAll({
        searchFields: 'description',
        search
      });
    }

    return this.http.get<any>(environment.API_URL + `/api/projects/${projectId}/configurations`, { params });
  }

  getColumns(projectId: number) {
    return this.http.get<any>(environment.API_URL + `/api/projects/${projectId}/scrumboard-columns?sort=index:ASC`);
  }
  getColumnsDrop(projectId: number, search?: any) {
    let params = new HttpParams();
    params = params.append('sort', 'index:ASC');
    if (search && search !== '') {
      params = params.appendAll({
        searchFields: 'name',
        search
      });
    }

    return this.http.get<any>(environment.API_URL + `/api/projects/${projectId}/scrumboard-columns`, { params })
      .pipe(
        tap(val => {
          val.data.unshift({ name: 'Backlog', id: Number(-1) });
          return val;
        })
      );
  }

  /*SUSBTASKS */

  getSubtasks(projectId: number, taskId: number) {
    return this.http.get<any>(environment.API_URL + `/api/projects/${projectId}/tasks/${taskId}/subtasks?relations=assigned,sprint,column,priority,type`);
  }
  createSubtask(taskId: number, data: any) {
    return this.http.post<any>(environment.API_URL + `/api/tasks/${taskId}/subtasks`, data, { headers: this.headers })
  }

  /*COMMENTS */

  getComments(taskId: number, pageSize: number) {
    let params = new HttpParams();
    params = params.appendAll({
      pageSize,
      relations: 'author,author.photo,uploadedFiles',
      sort: 'createdAt:DESC'
    });

    return this.http.get<any>(environment.API_URL + `/api/tasks/${taskId}/comments`, { params });
  }
  createComments(taskId: number, data: any) {
    return this.http.post<any>(environment.API_URL + `/api/tasks/${taskId}/comments`, data, { headers: this.headers })
  }
  deleteComments(taskId: number, commentId: number) {
    return this.http.delete<any>(environment.API_URL + `/api/tasks/${taskId}/comments/${commentId}`)
  }

  getMentions(projectId: number | null) {
    return this.http.get<any>(environment.API_URL + `/api/projects/${projectId}/users/mentions`)

  }

  /*HISTORY */
  getHistory(taskId: number, pageSize: number, page: number) {
    let params = new HttpParams();
    params = params.appendAll({
      pageSize,
      page,
      relations: 'author',
      sort: 'createdAt:DESC'
    });
    return this.http.get<any>(environment.API_URL + `/api/tasks/${taskId}/history`, { params });
  }

  getTimesList(pageSize: number, page: number, taskId:number,projectId:number) {
    let params = new HttpParams();
    params = params.appendAll({
      pageSize,
      page,
      relations: 'user',
      sort: 'start:DESC',
    });

    return this.http.get<any>(environment.API_URL + `/api/projects/${projectId}/tasks/${taskId}/periods`, { params });
  }

}


